import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://nepzklpprrpqxunngbos.supabase.co'
const supabaseKey = 'sb_publishable_ieYaHY0U1W21T1D9BJD-1A_27aBJLwB'

export const supabase = createClient(supabaseUrl, supabaseKey)